<script>
    import Icon from 'views/components/icon/Icon.svelte';
    import NumberInput from 'views/components/quickInput/numberInput/NumberInput';
    import Tooltip from 'views/components/toolTip/Tooltip.svelte';

    const { activityModel, taskModel } = $props()

    // svelte-ignore state_referenced_locally
    let points = $state(activityModel.getAttainableExamPoints(taskModel.id))
    let tooltipIsOpen = $state(false)

    function addPointsInput(element) {
        const pointsInput = new NumberInput({
            defaultValue: points,
            step: 0.5,
            autoFocus: true,
            inputCallbackWithoutButton: () => tooltipIsOpen = false
        })
        element.append(pointsInput.el)

        // On destroy, we save the points if they changed
        return () => {
            const newPoints = pointsInput.getInput()
            if (newPoints !== points) {
                activityModel.setAttainableExamPoints(taskModel.id, newPoints)
                points = activityModel.getAttainableExamPoints(taskModel.id)
            }
        }
    }

    function onClickPoints(e) {
        e.stopPropagation()
        tooltipIsOpen = !tooltipIsOpen
    }
</script>

<div class="container">
    <button class="points" onclick={onClickPoints}>{points.toLocaleString()}</button>

    <Tooltip bind:isOpen={tooltipIsOpen} alignment="right">
        <div class="header">
            <div class="title">{window.i18n.gettext('Edit points')}</div>
            <button class="close" onclick={() => tooltipIsOpen = false}><Icon name="cross"></Icon></button>
        </div>
        <div {@attach addPointsInput}></div>
    </Tooltip>
</div>
<div class="unit">{window.i18n.ngettext('point', 'points', points)}</div>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.container {
  display: flex;
  margin-top: 4px;
  position: relative;
}

.points {
  min-width: 32px;
  margin: auto;
  padding: 4px;
  text-align: center;
  background-color: #122d40;
  color: #fff;
  border-radius: 12px;
  font-weight: 600;
}
.points:hover {
  background-color: hsl(205, 60%, 44%);
}

.unit {
  font-size: 14px;
  font-variant-caps: all-small-caps;
  letter-spacing: 1px;
  line-height: 12px;
  margin-top: 2px;
  font-size: 12px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 4px;
  margin-bottom: 8px;
}
.header .title {
  color: hsl(205, 60%, 44%);
}
.header .close {
  display: flex;
  width: 16px;
  height: 16px;
}</style>
